import {
  AppInsightsContext,
  MetadataContext,
  ModuleBase,
  ReportsGrid,
  TrackEventKey,
  TrackEventName,
  TrackEventType,
  UserContext,
} from '@/components';
import {
  CognitiveFilterRequestModel,
  ModuleBaseModel,
  ModuleBasePropsModel,
  ReportSearchModel,
  UiConfigurationModel,
  ReportCardType,
} from '@/types';
import { useTranslations } from 'next-intl';
import { useRouter } from 'next/router';
import { useContext } from 'react';

type RelatedItemsModel = ModuleBaseModel<
  {
    heading: string;
    headingTag: string;
    description: string;
    anchor: string;
    uiConfiguration?: UiConfigurationModel;
    requestFilter?: CognitiveFilterRequestModel;
    cards: ReportSearchModel[];
    cardType: ReportCardType;
  } & ModuleBasePropsModel
>;

const RelatedItems = (data: RelatedItemsModel) => {
  const { props } = data;
  const t = useTranslations();
  const { isPublic, pageId } = useContext(MetadataContext);
  const appInsights = useContext(AppInsightsContext);
  const user = useContext(UserContext);
  const router = useRouter();

  const onCardClick = (e: React.MouseEvent, data: ReportSearchModel) => {
    appInsights.trackCustomEvent(TrackEventName.REPORT, TrackEventKey.RELATED_REPORT, TrackEventType.SELECTED, user, {
      pageId,
      pagePath: router.asPath,
      reportID: data.reportId,
    });
  };

  return (
    <ModuleBase
      data={{ ...data, props: { ...props, noPaddingOnTop: true, anchor: 'report-related-items' } }}
      className="overflow-hidden print:hidden"
    >
      <div className="mx-auto [&_.heading]:text-lg [&_.heading]:font-bold">
        <ReportsGrid
          uiConfiguration={props.uiConfiguration || { pageSize: 100, limit: 1, layout: 'singleRowDrag' }}
          cards={props.cards}
          cardType={props.cardType}
          requestFilter={props.requestFilter}
          heading={{
            heading: isPublic ? t('report.$youmightalsolike') : t('report.relatedItems.$relatedItemsHeading'),
            description: t('report.relatedItems.$relatedItemsDescription'),
          }}
          onCardClick={onCardClick}
        />
      </div>
    </ModuleBase>
  );
};

export default RelatedItems;
